import { showNotification } from './notification';
import { lang } from './utils';

export const getItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const labels = {
  en: {
    error: 'Error',
    message:
      'This feature requires access to your local browser storage. You may have disabled cookies in your browser settings. Please enable them to use this feature.',
  },
  de: {
    error: 'Fehler',
    message:
      'Diese Funktion erfordert den Zugriff auf Ihren lokalen Browser-Speicher. Möglicherweise haben Sie in den Einstellungen Ihres Browsers Cookies deaktiviert. Bitte aktivieren Sie diese, um diese Funktion zu nutzen. ',
  },
} as const;

export const setItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    showNotification(labels[lang].error, labels[lang].message);
  }
};
